import { render, staticRenderFns } from "./answerSheet.vue?vue&type=template&id=53f48f2e&scoped=true"
import script from "./answerSheet.vue?vue&type=script&lang=js"
export * from "./answerSheet.vue?vue&type=script&lang=js"
import style0 from "./answerSheet.vue?vue&type=style&index=0&id=53f48f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f48f2e",
  null
  
)

export default component.exports